import { countryOptions, languageOptions, categoryOptions } from '@/mocks/discoverySocial';

interface DiscoveryFilterBarProps {
  country: string;
  language: string;
  category: string;
  onCountryChange: (v: string) => void;
  onLanguageChange: (v: string) => void;
  onCategoryChange: (v: string) => void;
  totalResults: number;
}

export default function DiscoveryFilterBar({
  country,
  language,
  category,
  onCountryChange,
  onLanguageChange,
  onCategoryChange,
  totalResults,
}: DiscoveryFilterBarProps) {
  return (
    <div className="py-5 border-b border-background-200/70">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-center gap-4">
          {/* Result count */}
          <span className="text-xs font-semibold text-foreground-500 whitespace-nowrap">
            {totalResults} resultado{totalResults !== 1 ? 's' : ''}
          </span>

          <div className="flex flex-wrap items-center gap-2.5">
            {/* País */}
            <div className="flex items-center gap-1.5">
              <i className="ri-earth-line text-foreground-400 text-sm w-4 h-4 flex items-center justify-center"></i>
              <select
                value={country}
                onChange={(e) => onCountryChange(e.target.value)}
                className="text-xs font-semibold bg-background-100 border border-background-200 rounded-lg px-3 py-2 text-foreground-700 cursor-pointer outline-none focus:border-foreground-400 transition-colors appearance-none pr-7"
              >
                {countryOptions.map((opt) => (
                  <option key={opt} value={opt}>{opt === 'Todos' ? 'Todos los países' : opt}</option>
                ))}
              </select>
            </div>

            {/* Idioma */}
            <div className="flex items-center gap-1.5">
              <i className="ri-translate-2 text-foreground-400 text-sm w-4 h-4 flex items-center justify-center"></i>
              <select
                value={language}
                onChange={(e) => onLanguageChange(e.target.value)}
                className="text-xs font-semibold bg-background-100 border border-background-200 rounded-lg px-3 py-2 text-foreground-700 cursor-pointer outline-none focus:border-foreground-400 transition-colors appearance-none pr-7"
              >
                {languageOptions.map((opt) => (
                  <option key={opt} value={opt}>{opt === 'Todos' ? 'Todos los idiomas' : opt}</option>
                ))}
              </select>
            </div>

            {/* Categoría */}
            <div className="flex items-center gap-1.5">
              <i className="ri-price-tag-3-line text-foreground-400 text-sm w-4 h-4 flex items-center justify-center"></i>
              <select
                value={category}
                onChange={(e) => onCategoryChange(e.target.value)}
                className="text-xs font-semibold bg-background-100 border border-background-200 rounded-lg px-3 py-2 text-foreground-700 cursor-pointer outline-none focus:border-foreground-400 transition-colors appearance-none pr-7"
              >
                {categoryOptions.map((opt) => (
                  <option key={opt} value={opt}>{opt === 'Todas' ? 'Todas las categorías' : opt}</option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}